import { Link } from "react-router-dom";
import styled from "styled-components";

export const SideSection = styled.aside`
  position: sticky;
  top: 0;
  width: ${({ isShowSidebar, fixed }) =>
    isShowSidebar && fixed ? "66px" : "270px"};
  transform: ${({ isShowSidebar }) =>
    isShowSidebar ? "translateX(0px)" : "translateX(0)"};
  transition: 0.3s all ease-in-out;
  height: 100vh;
  display: flex;
  flex-direction: column;
  box-shadow: rgb(0 0 0 / 14%) -4px -11px 51px !important;
  background-color: ${({ theme }) => theme.backgroundSidebar};
  overflow: hidden;

  &:hover {
    width: 270px;
    transition: width 0.4s ease-in-out;
  }

  @media (max-width: 576px) {
    width: ${({ isShowSidebar }) => (isShowSidebar ? "0px" : "270px")};
    position: fixed;
    transform: ${({ isShowSidebar }) =>
      isShowSidebar ? "translateX(270px)" : "translateX(0px)"};
    z-index: 1;
  }
`;

export const Nav = styled.nav`
  display: flex;
  align-items: center;
  padding: 1rem 0.5rem;
`;

export const NavList = styled.ul`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
`;

export const NavListItem = styled.li`
  display: flex;
  align-items: center;
  width: 100%;
  padding: ${({ menu }) => (menu ? "0rem" : ".2rem")};
  cursor: pointer;
  border-radius: 3px;
  /* transition: 0.4s display ease-in-out; */
`;

export const NavLink = styled(Link)`
  /* font-size: 12px; */
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: 0.4s transform ease-in-out;
  color: ${({ theme }) => theme.text};
  &:hover {
    transform: translateX(5px);
  }
`;

export const Container = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const SubListMenu = styled.div`
  width: 100%;
  /* margin-right: 10px; */
`;
export const Header = styled.div`
  padding: ${({ isShowSidebar }) => (isShowSidebar ? "0rem 0rem" : "0 1rem")};
  height: 50px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid ${({ theme }) => theme.border};

  .close {
    display: none;
  }
  @media (max-width: 576px) {
    .close {
      display: flex;
      justify-content: center;
      align-items: center;
      margin: 0 1rem;
      cursor: pointer;
    }
  }
`;

export const Icon = styled.div`
  margin: 0 0.5rem 0 0.2rem;
  display: flex;
  justify-content: center;
  align-items: center;
  @media (max-width: 768px) {
    margin: 0px;
  }
  /* box-shadow: ${({ theme }) => theme.shadow}; */
  svg {
    cursor: pointer;
    &:hover {
      color: ${({ theme }) => theme.text};
      transition: 0.4s all ease-in-out;
    }
  }
  @media (max-width: 560px) {
    svg {
      width: 15px;
    }
  }
`;

export const Img = styled.img`
  width: 40px;
  height: 40px;
  border-radius: 50%;
  border: 1px solid #fa7f04;
`;

export const SubHeader = styled.div`
  padding: 0 10px;
  display: flex;
  align-items: center;
  height: 50px;
  border-bottom: 1px solid ${({ theme }) => theme.border};
  transition: 0.4s all ease-in-out;
`;
